import React, { useRef } from 'react';
import { Box } from '@mui/material';
import CarouselHeader from './CarouselHeader';
import Slider from 'react-slick';
import { breakpoints } from '../../../assets/styles/themes/tokens';
import { numberOfSlides } from '../../../constants';
interface NewCarouselProps {
  title: string;
  slidesCount: number;
  onShowAll: () => void;
}

const NewCarousel: React.FC<NewCarouselProps> = (props) => {
  const { title, onShowAll, children, slidesCount } = props;
  const sliderRef = useRef<Slider>(null);
  const { carouselBreakpoints } = breakpoints;

  const settings = {
    infinite: !(slidesCount <= numberOfSlides.xl),
    speed: 500,
    slidesToShow: numberOfSlides.xl,
    slidesToScroll: numberOfSlides.lg,
    responsive: [
      {
        breakpoint: carouselBreakpoints.lg,
        settings: {
          slidesToShow: numberOfSlides.lg,
          slidesToScroll: Math.floor(numberOfSlides.lg)
        }
      },
      {
        breakpoint: carouselBreakpoints.md,
        settings: {
          slidesToShow: numberOfSlides.md,
          slidesToScroll: Math.floor(numberOfSlides.md)
        }
      },
      {
        breakpoint: carouselBreakpoints.sm,
        settings: {
          infinite: false,
          slidesToShow: numberOfSlides.sm,
          slidesToScroll: numberOfSlides.xxs,
        }
      },
      {
        breakpoint: carouselBreakpoints.xs,
        settings: {
          infinite: false,
          slidesToShow: numberOfSlides.xs,
          slidesToScroll:  numberOfSlides.xxs,
        }
      }
    ]
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CarouselHeader 
        title={title}
        onSlideNext={() => {
          sliderRef.current?.slickNext();
        }}
        onSlidePrev={() => sliderRef.current?.slickPrev()}
        onShowAll={onShowAll} 
      />
      <Box
        data-testid='carousel' 
        sx={{ 
          width: '100%', 
          display: 'flex', 
          justifyContent: 'center', 
          flexDirection: 'column', 
          overflow: 'hidden' 
        }}
      >
        <Slider 
          ref={sliderRef} 
          {...settings}
        >
          {children}
        </Slider>
      </Box>
    </Box>
  );
};

export default NewCarousel;
